module.exports = __webpack_public_path__ + "static/img/99zhuanqu.4642815.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/99zhuanqu.png
// module id = EeUf
// module chunks = 1